var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tagged-gallery-property',{attrs:{"c_permission_e":_vm.c_permission_e,"ac_key":_vm.AC_PROPERTY_GALLERY,"c_permission_v":_vm.c_permission_v}})}
var staticRenderFns = []

export { render, staticRenderFns }